import {WOW} from 'wowjs';
import {Chart} from 'chart.js';
import 'chartjs-plugin-deferred';

export default {
  init() {
// JavaScript to be fired on all pages
$(function() {
  $('#issue33').toast('show');
  setTimeout(function() {
      $('#issue33').removeClass('toast toast--master-1 wow slideInRight fade show').addClass('toast toast--master-1 wow backOutRight fade show');
  }, 10000);
  setTimeout(function() {
      $('#issue34').removeClass('toast--master-bg-1').addClass('toast--master-bg-2');
      $('#issue33').removeClass('toast toast--master-1 wow slideOutRight fade hide').addClass('toast toast--master-2 wow slideInRight fade show');
  }, 15000);
});
const wow = new WOW();
wow.init();
  },
  finalize() {
// JavaScript to be fired on all pages, after page specific JS is fired

/* eslint-disable  no-unused-vars */
var ctx = document.getElementById('TotalRedHelp').getContext('2d');
var ctx2 = document.getElementById('AgeGroup').getContext('2d');
var ctx3 = document.getElementById('DidUKnow').getContext('2d');
var gradientStroke = ctx.createLinearGradient(0, 500, 0, 100);
gradientStroke.addColorStop(0, '#00abc8');
gradientStroke.addColorStop(1, '#f79671');

var myChart = new Chart(
  ctx, {
    type: 'bar',
    data: {
        labels: ['2016', '2017', '2018', '2019'],
        datasets: [{
            label: 'Total Residents Helped',
            data: [23850, 23560, 28257, 39262],
            backgroundColor: [gradientStroke,gradientStroke,gradientStroke,gradientStroke],
            borderColor: [gradientStroke,gradientStroke,gradientStroke,gradientStroke],
            borderWidth: 1,
        }]},
    options: {plugins: {deferred: {xOffset: 150, yOffset: '50%',delay: 1800} },
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: true,
},
}],
},
},
});
var maChart = new Chart(
ctx2, {
    type: 'bar',
    data: {
        labels: ['Youth', 'Adults', 'Seniors'],
        datasets: [{
            label: 'Increased%',
            data: [14, 79, 48],
            backgroundColor: [gradientStroke,gradientStroke,gradientStroke,gradientStroke],
            borderColor: [gradientStroke,gradientStroke,gradientStroke,gradientStroke],
            borderWidth: 1,
            responsive: true,
        }],
    },
    options: {plugins: {deferred: {xOffset: 150, yOffset: '50%',delay: 1200} },scales: {yAxes: [{ticks: {stepSize: 10,callback: function(value, index, values) {return ((value / 100) * 100) + '%';}}}]}},
  });
var arChart = new Chart(
  ctx3, {
    type: 'bar',
    data: {
        labels: ['West Chester', 'Oxford', 'Fairfield', 'Hamilton', 'Middletown'],
        datasets: [{
            label: 'Increased%',
            data: [65, 65, 28, 78, 114],
            backgroundColor: [gradientStroke,gradientStroke,gradientStroke,gradientStroke,gradientStroke],
            borderColor: [gradientStroke,gradientStroke,gradientStroke,gradientStroke,gradientStroke],
            borderWidth: 1,
            responsive: true,
        }],
    },
    options: {plugins: {deferred: {xOffset: 150, yOffset: '50%',delay: 1200} },
        scales: {
            yAxes: [{
                ticks: {stepSize: 20,callback: function(value, index, values) {return ((value / 100) * 100) + '%';}}}]}}});
/* eslint-enable  */

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js